import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';

const MinistryLayout = ({ 
  title, 
  description, 
  leaders,
  coverImage, 
  vision, 
  mission, 
  activities, 
  schedules, 
  children 
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Ministry Hero */}
      <PageHeader 
        title={title}
        subtitle={description}
        imageUrl={coverImage}
        imageAlt={title}
      />
      {/* Ministry Content */}
      <div className="container mx-auto px-4 py-10">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Sidebar */}
          <div className="md:col-span-1">
            {leaders && (
              <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Ministry Leaders</h3>
                  {
                    leaders.map((leader) => (
                      <div className="flex items-center p-1">
                    <img 
                      src={leader.profile_image} 
                      alt={leader.name} 
                      className="w-20 h-20 rounded-full object-cover mr-4"
                    />
                    <div>
                      <h4 className="font-medium text-gray-900">{leader.name}</h4>
                      <p className="text-gray-600">{leader.campusName}</p>
                    </div>
                  </div>
                    ))
                  }
                  
                </div>
              </div>
            )}

            {schedules && schedules.length > 0 && (
              <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Meeting Schedule</h3>
                  <ul className="space-y-3">
                    {schedules.map((schedule, index) => (
                      <li key={index} className="flex space-x-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <span className="text-gray-700">{schedule.title}-{Intl.DateTimeFormat('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                    }).format(new Date(schedule.date))}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Get Involved</h3>
                <p className="text-gray-600 mb-4">
                  Would you like to be part of this ministry? We'd love to have you join us!
                </p>
                <Link 
                  to="/contact" 
                  className="inline-block bg-indigo-600 text-white px-4 py-2 rounded font-medium hover:bg-indigo-700 transition duration-200"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="md:col-span-2">
            {(vision || mission) && (
              <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                <div className="grid md:grid-cols-2 gap-6">
                  {vision && (
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">Our Vision</h3>
                      <p className="text-gray-700">{vision}</p>
                    </div>
                  )}
                  {mission && (
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-3">Our Mission</h3>
                      <p className="text-gray-700">{mission}</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activities && activities.length > 0 && (
              <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Activities & Programs</h3>
                <ul className="space-y-4">
                  {activities.map((activity, index) => (
                    <li key={index} className="flex items-start">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-500 mr-2 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-gray-700">{activity}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Additional content */}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MinistryLayout; 